var Promise = require("bluebird");

// const config = {
// 	host: 'usrad-fka.qliktech.com',
// 	prefix: '/',
// 	port: 443,
// 	isSecure: true,
// 	identity: new Date().getUTCMilliseconds()
// };
const config = {
	host: 'sense-demo.qlik.com',
	prefix: '/',
	port: 443,
	isSecure: true,
	identity: new Date().getUTCMilliseconds()
};


window.require.config({
	baseUrl: (config.isSecure ? "https://" : "http://" ) + config.host + (config.port ? ":" + config.port : "" ) + config.prefix + "resources"
});

export default new Promise((resolve) => {
  window.require( ["js/qlik"], function ( qlik ) {
    //let app = qlik.openApp('0020a1b3-28f2-4e02-853a-65578f701ece', config);
		let app = qlik.openApp('1bbf7f54-c9e9-4b7b-b2ce-46f37eefd32a', config);
    resolve(app);
  });
});


// WEBPACK FOOTER //
// ./qapp.js